import { render, staticRenderFns } from "./OrderBackNext.vue?vue&type=template&id=100fe0ba&"
import script from "./OrderBackNext.vue?vue&type=script&lang=js&"
export * from "./OrderBackNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports